import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar p-mr-2 p-p-2" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, "Dal:  ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar p-mr-2 p-p-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Al:  ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-map p-mr-2 p-p-2" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Città:  ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chip = _resolveComponent("Chip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Chip, null, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _createTextVNode(" " + _toDisplayString(_ctx.from?.split('-').reverse().join('/')), 1)
      ]),
      _: 1
    }),
    _createVNode(_component_Chip, { class: "p-ml-2" }, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.to?.split('-').reverse().join('/')), 1)
      ]),
      _: 1
    }),
    (_ctx.zoneName)
      ? (_openBlock(), _createBlock(_component_Chip, {
          key: 0,
          class: "p-ml-2"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_ctx.zoneName), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}